<script>
export default {
    props: {
        items: {
            type: Object,
            required: true
        },
        links: {
            type: Object,
            default: () => ({})
        },
        statuses: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        filteredItems() {
            return Object.fromEntries(
                Object.entries(this.items).filter(([key, value]) =>
                    value !== null && value !== undefined && value !== '' && value !== 'N/A'
                )
            );
        },
        getStatusClass() {
            return (key) => {
                const status = this.statuses[key] || 'normal';

                return {
                    'normal': 'text-gray-900',
                    'warning': 'text-yellow-700 bg-yellow-50 px-2 py-0.5 rounded w-fit',
                    'danger': 'text-red-700 bg-red-50 px-2 py-0.5 rounded w-fit'
                }[status];

            };
        }
    }
}
</script>

<template>
    <div class="grid grid-cols-4 gap-6">
        <div v-for="(value, key) in filteredItems" :key="key" class="flex flex-col gap-2">
            <p class="text-xs font-medium text-gray-700 uppercase tracking-wide p-0 m-0">{{ key }}</p>

            <a v-if="links[key]"
               :href="links[key]"
               target="_blank"
               :class="['text-base font-medium p-0 m-0 hover:text-blue-500 hover:no-underline focus:text-blue-600 focus:no-underline', getStatusClass(key)]">
                {{ value }}
                <span class="lnr icon-link !text-blue-500 !text-base ml-2 hover:no-underline"></span>
            </a>

            <p v-else :class="['text-base font-medium p-0 m-0', getStatusClass(key)]">{{ value }}</p>
        </div>
    </div>
</template>

